import React from 'react';
import logo from '../assets/logo.jpg';
import { IconMap } from '../lib';

import { AppIcons } from '../lib/icons/AppIcons';

interface FooterProps {}

const Footer: React.FC<FooterProps> = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src={logo} alt="Childs Play Mucklagh" />
              <span className="footer-brand">Childs Play Mucklagh</span>
            </div>
            <p>
              Two Generations, One Legacy of Passion, Shaping Life Long Memories.
            </p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home" onClick={() => scrollToSection('home')}>Home</a></li>
              <li><a href="#services" onClick={() => scrollToSection('services')}>Services</a></li>
              <li><a href="#features" onClick={() => scrollToSection('features')}>About Us</a></li>
              <li><a href="#schemes" onClick={() => scrollToSection('schemes')}>Schemes</a></li>
              <li><a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><a href="#services">Breakfast Club</a></li>
              <li><a href="#services">Sessional Care</a></li>
              <li><a href="#services">After-School Programme</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="footer-contact">
              <p>
                <AppIcons icon={IconMap.faMapMarkedAlt} variant='footerContact'/>
                <a href="https://www.google.com/maps/search/?api=1&query=Childs+Play+Pre+School+Brocca+Rd+Mucklagh+Co+Offaly" target="_blank" rel="noopener noreferrer">Brocca Road, Mucklagh, Tullamore, Co Offaly, R35 W568</a>
              </p>
              <p>
                <AppIcons icon={IconMap.faPhone} variant='footerContact'/>
                <a href="tel:+353868784903">+353 86 878 4903</a>
              </p>
              <p>
                <AppIcons icon={IconMap.faEnvelope} variant='footerContact'/>
                <a href="mailto:info@childsplaymucklagh.ie">info@childsplaymucklagh.ie</a>
              </p>
              <p>
                <AppIcons icon={IconMap.faClock} variant='footerContact'/>
                Mon - Thu: 8:00 AM - 6:00 PM | Fri: 8:00 AM - 5:00 PM
              </p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Childs Play Mucklagh. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 